import { render, staticRenderFns } from "./ResponseActionTable.vue?vue&type=template&id=c89dd0b6"
import script from "./ResponseActionTable.vue?vue&type=script&lang=ts"
export * from "./ResponseActionTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports